'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_ValidationPage(code) {
  this.Dq = null;
  this.Dq = code;
}
export { $c_Lpresto_ValidationPage as $c_Lpresto_ValidationPage };
$p = $c_Lpresto_ValidationPage.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ValidationPage;
/** @constructor */
function $h_Lpresto_ValidationPage() {
}
export { $h_Lpresto_ValidationPage as $h_Lpresto_ValidationPage };
$h_Lpresto_ValidationPage.prototype = $p;
$p.dl = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
});
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_ValidationPage)) {
    var x = this.Dq;
    var x$2 = x$0.Dq;
    return ((x === null) ? (x$2 === null) : x.i(x$2));
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "ValidationPage";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Dq;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_ValidationPage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.j3)));
}
export { $isArrayOf_Lpresto_ValidationPage as $isArrayOf_Lpresto_ValidationPage };
var $d_Lpresto_ValidationPage = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ValidationPage, "presto.ValidationPage", ({
  j3: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_ValidationPage as $d_Lpresto_ValidationPage };
//# sourceMappingURL=presto.-Validation-Page.js.map
